<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row m-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">

          <div class="row">
            <div class="form-group me-2 col-md-3 col-lg-3 col-xl-2">
              <div class="col p-0">
                <div class="">
                  <input type="text" class="form-control form-control-sm" @keydown.enter="() => applyFilters()" :placeholder="helper.trans('labels.search_traffic_group')" v-model="requestDTO.query">
                </div>
              </div>
            </div>

            <div class="form-group col">
              <div class="col-auto p-0 text-end ">
                <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="row  m-4 mt-0">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-12">
            <div class="card card-body">
              <div class="overflow-auto">
                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first">{{ helper.trans('labels.id') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.type') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.name') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.group_payment_option') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.team_fee') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.merchant_fee') }}</th>
                    <th class="text-capitalize-first">{{ helper.trans('labels.margin_fee') }}</th>
                    <th class="text-end">
                      <button v-if="store.getters.isAdmin" type="button" v-on:click="showEditModal()" class="btn btn-outline-primary btn-sm text-capitalize">{{ helper.trans('button.create') }}</button>
                      <b-modal
                               :title="createModalTitle"
                               :modelValue="createModal"
                               body-class="pt-0"
                               @update:modelValue="createModal = $event"
                      >
                        <template #default>
                          <TrafficGroupForm ref="createForm"></TrafficGroupForm>
                        </template>
                        <template #footer>
                          <button type="button" v-on:click="createModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                          <LoaderWrapper ref="loaderCreateFrom" :zoom="0.5">
                            <button type="button" @click="save()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.save') }}</button>
                          </LoaderWrapper>
                        </template>
                      </b-modal>
                      <b-modal
                               :title="rateChangeModalTitle"
                               :modelValue="rateChangeModal"
                               body-class="pt-0"
                               @update:modelValue="rateChangeModal = $event"
                      >
                        <template #default>
                          <TrafficGroupRateChangeForm ref="rateChangeForm" :trafficGroupId="selectedTrafficGroupId"></TrafficGroupRateChangeForm>
                        </template>
                        <template #footer>
                          <button type="button" v-on:click="rateChangeModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                          <LoaderWrapper ref="loaderRateChangeFrom" :zoom="0.5">
                            <button type="button" @click="saveRateChange()" class="btn btn-outline-primary btn-sm text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                          </LoaderWrapper>
                        </template>
                      </b-modal>
                      <b-modal
                               :title="deleteModalTitle"
                               :modelValue="deleteModal"
                               body-class="pt-0"
                               @update:modelValue="deleteModal = $event"
                      >
                        <template #default>
                          <p>{{ helper.trans('messages.confirm_delete_traffic_group', {name: selectedTrafficGroupName}) }}</p>
                        </template>
                        <template #footer>
                          <button type="button" v-on:click="deleteModal = false" class="btn btn-outline-secondary btn-sm text-capitalize-first">{{ helper.trans('button.cancel') }}</button>
                          <LoaderWrapper ref="loaderDelete" :zoom="0.5">
                            <button type="button" @click="deleteTrafficGroup()" class="btn btn-outline-danger btn-sm text-capitalize-first">{{ helper.trans('button.delete') }}</button>
                          </LoaderWrapper>
                        </template>
                      </b-modal>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in response.items" :key="item.id" class="">
                    <td>{{ item.id }} <i v-if="item.isHidden" class="fa fa-eye-slash"></i> </td>
                    <td>{{ helper.trans(`direction.${item.type}`) }}</td>
                    <td>{{ item.name }} <small v-if="item.publicName">({{item.publicName}})</small></td>
                    <td>
                      <template v-if="item.paymentOptions?.length">
                        <span v-for="option in item.paymentOptions" :key="option" class="badge bg-primary me-1">
                          {{ helper.trans(`payment_options.${option}`) }}
                        </span>
                      </template>
                      <span v-else>—</span>
                    </td>
                    <td>
                      <div v-if="item._traderGroupSummaryItem">
                        <span v-if="item._traderGroupSummaryItem.minReward === item._traderGroupSummaryItem.maxReward">
                          {{numberFormatter.formatNumber(item._traderGroupSummaryItem?.minReward * 100, 2)}}
                        </span>
                        <span v-else>
                          {{numberFormatter.formatNumber(item._traderGroupSummaryItem?.minReward * 100, 2)}}/{{numberFormatter.formatNumber(item._traderGroupSummaryItem?.maxReward * 100, 2)}}
                        </span>
                      </div>
                    </td>
                    <td>
                       <span v-if="item.minReward === item.maxReward">
                          {{numberFormatter.formatNumber(item.minReward * 100, 2)}}
                        </span>
                      <span v-else>
                          {{numberFormatter.formatNumber(item.minReward * 100, 2)}}/{{numberFormatter.formatNumber(item.maxReward * 100, 2)}}
                      </span>
                    </td>
                    <td>
                       <span v-if="item.minReward - (item._traderGroupSummaryItem?.maxReward ?? 0) === item.maxReward - (item._traderGroupSummaryItem?.minReward ?? 0) ">
                          {{numberFormatter.formatNumber((item.minReward - (item._traderGroupSummaryItem?.maxReward ?? 0)) * 100, 2)}}
                        </span>
                      <span v-else>
                          {{numberFormatter.formatNumber((item.minReward - (item._traderGroupSummaryItem?.maxReward ?? 0)) * 100, 2)}}/{{numberFormatter.formatNumber((item.maxReward - (item._traderGroupSummaryItem?.minReward ?? 0)) * 100, 2)}}
                      </span>
                      <i v-if="(item._traderGroupSummaryItem?.minReward ?? 0) >= 0 && item.minReward - (item._traderGroupSummaryItem?.maxReward ?? 0) < 0.01" class="fa fa-warning text-warning ms-2"></i>
                    </td>
                    <td class="text-end">
                      <button v-if="store.getters.isAdmin" type="button" @click="showRateChangeModal(item)" class="btn btn-sm btn-outline-primary text-nowrap text-capitalize me-2"><i class="fa fa-percent"></i> {{helper.trans('button.rates')}}</button>
                      <button v-if="store.getters.isAdmin" type="button" @click="showEditModal(item)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize me-2"><i class="fa fa-pencil"></i> {{helper.trans('button.edit')}}</button>
                      <button v-if="store.getters.isAdmin" type="button" @click="showDeleteModal(item)" class="btn btn-sm btn-outline-danger text-nowrap text-capitalize"><i class="fa fa-trash"></i> {{helper.trans('button.delete')}}</button>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="response.totalCount > response.items.length"
                  v-model="page"
                  :total-rows="response.totalCount"
                  :per-page="response.limit"
                  :limit="20"
                  @update:modelValue="loadList()"
                  prev-text="Back"
                  next-text="Next"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import TrafficGroupDTO from "@/models/TrafficGroupDTO";
import TrafficGroupForm from "@/components/Form/TrafficGroupForm.vue";
import TrafficGroupRateChangeForm from "@/components/Form/TrafficGroupRateChangeForm.vue";
import TrafficGroupFormDTO from "@/models/form/TrafficGroupFormDTO";
import {Dictionary} from "@/types";
import TraderGroupSummaryItemDTO from "@/models/TraderGroupSummaryItemDTO";


const notification = useNotification()
const defaultForm = {
  id: null,
  name: null,
  publicName: null,
  type: null,
  isHidden: false,
  minSum: null,
  maxSum: null,
  currency: null,
  paymentOptions: [],
} as TrafficGroupFormDTO

export default defineComponent({
  components: {
    TrafficGroupForm,
    TrafficGroupRateChangeForm,
    LoaderWrapper,
    CopyButton,
    BPagination,
  },
  setup() {
    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderCreateFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderRateChangeFrom = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderDelete = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const createForm = ref<InstanceType<typeof TrafficGroupForm> | null>(null)
    const rateChangeForm = ref<InstanceType<typeof TrafficGroupRateChangeForm> | null>(null)

    const state = reactive({
      createModalTitle: '',
      createModal: false,
      rateChangeModalTitle: '',
      rateChangeModal: false,
      deleteModalTitle: '',
      deleteModal: false,
      selectedTrafficGroupId: 0,
      selectedTrafficGroupName: '',
      page: 1,
      requestDTO: {
        query: '',
      } as any,
      response: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<TrafficGroupDTO>
    });

    const loadList = async () => {
      loader.value?.show()

      state.response.offset = state.response.limit * (state.page - 1)
      state.response = await api.call.trafficGroups.list(state.response, state.requestDTO)
      const ids = state.response.items.map(item => item.id)
      if (ids.length > 0) {
        const summaryItemByGroupId: Dictionary<TraderGroupSummaryItemDTO> = {}
        for (const item of (await api.call.traderRewardSettings.summary({ids}))) {
          summaryItemByGroupId[item.trafficGroupId] = item
        }
        for (const item of state.response.items) {
          item._traderGroupSummaryItem = summaryItemByGroupId[item.id] ?? null;
        }
      }

      loader.value?.hide()
    }

    const showEditModal = async (dto: TrafficGroupDTO|null = null) => {
      if (dto) {
        state.createModalTitle = helper.trans("labels.edit_traffic_group", {name: dto.name})
        createForm.value?.setForm({
          ...defaultForm,
          ...dto,
          minSum: dto.minSum?.amount,
          maxSum: dto.maxSum?.amount,
          paymentOptions: dto.paymentOptions ?? [],
        } as TrafficGroupFormDTO)
      } else {
        state.createModalTitle = helper.trans("labels.create_traffic_group")
        createForm.value?.setForm({...defaultForm} as TrafficGroupFormDTO)
      }

      state.createModal = true;
    }

    const save = () => {
      loaderCreateFrom.value?.show()

      createForm.value!.save()
        .then(() => {
          state.createModal = false;
          loadList();
        })
        .finally(() => {
          loaderCreateFrom.value?.hide();
        })
    }

    const showRateChangeModal = async (dto: TrafficGroupDTO) => {
      state.rateChangeModalTitle = helper.trans("labels.change_rates_for_group", {name: dto.name})
      state.selectedTrafficGroupId = dto.id
      rateChangeForm.value?.reset()
      state.rateChangeModal = true;
    }

    const saveRateChange = () => {
      loaderRateChangeFrom.value?.show()

      rateChangeForm.value!.save()
        .then(() => {
          state.rateChangeModal = false;
          loadList();
        })
        .finally(() => {
          loaderRateChangeFrom.value?.hide();
        })
    }

    const showDeleteModal = async (dto: TrafficGroupDTO) => {
      state.deleteModalTitle = helper.trans("labels.delete_traffic_group")
      state.selectedTrafficGroupId = dto.id
      state.selectedTrafficGroupName = dto.name
      state.deleteModal = true;
    }

    const deleteTrafficGroup = () => {
      loaderDelete.value?.show()

      api.call.trafficGroups.delete(state.selectedTrafficGroupId)
        .then(() => {
          state.deleteModal = false;
          notification.notify({
            type: 'success',
            title: helper.trans('success'),
            text: helper.trans('success.traffic_group_deleted')
          })
          loadList();
        })
        .catch((error) => {
          notification.notify({
            type: 'error',
            title: helper.trans('error'),
            text: helper.trans('error.unable_to_delete_traffic_group')
          })
        })
        .finally(() => {
          loaderDelete.value?.hide();
        })
    }


    const applyFilters = async () => {
      state.page = 1;
      loadList()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.requestDTO = {
        query: ''
      }
      loadList()
    }

    onMounted(async () => {
      loadList()
    });

    return {
      ...toRefs(state),
      store,
      loader,
      loaderCreateFrom,
      loaderRateChangeFrom,
      loaderDelete,
      dateHelper,
      numberFormatter,
      helper,
      createForm,
      rateChangeForm,
      save,
      showEditModal,
      showRateChangeModal,
      saveRateChange,
      showDeleteModal,
      deleteTrafficGroup,
      loadList,
      applyFilters,
      clearFilters,
    }
  }
})
</script>
